// Chrome's translator wraps text nodes in <font>, so React's removeChild/insertBefore on stale refs throws NotFoundError.
// Fall back to a no-op or append on mismatch (facebook/react#11538). Import before React renders.
let warned = false

function warnOnce(method: string) {
  if (warned) return
  warned = true
  console.warn(`[translateDomGuard] ignored a stale ${method} call (likely Chrome's page translator)`)
}

const originalRemoveChild = Node.prototype.removeChild
const originalInsertBefore = Node.prototype.insertBefore

Node.prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
  if (child.parentNode !== this) {
    warnOnce('removeChild')
    return child
  }
  return originalRemoveChild.call(this, child) as T
}

Node.prototype.insertBefore = function insertBefore<T extends Node>(
  this: Node,
  newNode: T,
  referenceNode: Node | null,
): T {
  if (referenceNode && referenceNode.parentNode !== this) {
    warnOnce('insertBefore')
    return originalInsertBefore.call(this, newNode, null) as T
  }
  return originalInsertBefore.call(this, newNode, referenceNode) as T
}
